import { takeEvery, put, call, select } from "redux-saga/effects"
//******************************************************************************
// ***************************** CONSTANTS *************************************
//******************************************************************************
import {
  GET_RISK,
  GET_RISK_NO_ARCHIVE,
  GET_RISK_BY_ID,
  GET_RISK_BY_MAPPING_RISK_ID,
  POST_RISK,
  PATCH_RISK_BY_ID,
  DELETE_RISK_BY_ID,
  // RISK RESIDUAL
  GET_RISK_RESIDUAL,
  GET_RISK_RESIDUAL_BY_ID,
  POST_RISK_RESIDUAL,
  PATCH_RISK_RESIDUAL_BY_ID,
  DELETE_RISK_RESIDUAL_BY_ID,
  //Mapping Risks
  GET_MAPPING_RISK,
  GET_MAPPING_RISK_BY_ID,
  GET_HISTORIC_OF_MAPPING_RISK_BY_ID,
  POST_MAPPING_RISK,
  PATCH_MAPPING_RISK_BY_ID,
  DELETE_MAPPING_RISK_BY_ID,
  // MATRICE DES RISQUES
  GET_MATRICE_RISK,
  GET_MATRICE_RISK_BY_ID,
  GET_FRENQUENCIES_AND_IMPACTS,
  GET_CALCUL_RISK_BRUT_RESULT,
  POST_MATRICE_RISK,
  PATCH_MATRICE_RISK_BY_ID,
  // CONFORMITY SCALE
  GET_CONFORMITY_SCALE,
  GET_CONFORMITY_SCALE_BY_CONTROL,
  POST_CONFORMITY_SCALE,
} from "../Risks/constants.js"
//******************************************************************************
// ***************************** ACTIONS ***************************************
//******************************************************************************
import {
  getRiskAction,
  getRiskSuccess,
  getRiskNoArchiveAction,
  getRiskByIdSuccess,
  getRiskByMappingRiskIdSuccess,
  postRiskSuccess,
  // Risk Residual
  getRiskResidualAction,
  getRiskResidualSuccess,
  getRiskResidualByIdSuccess,
  postRiskResidualSuccess,
  // Mapping Risk
  getMappingRiskAction,
  getMappingRiskSuccess,
  getMappingRiskByIdSuccess,
  getHistoricOfMappingRiskByIdSuccess,
  postMappingRiskSuccess,
  // Matrice Risk
  getMatriceRiskAction,
  getMatriceRiskSuccess,
  getMatriceRiskByIdSuccess,
  getCalculRiskBrutResultSuccess,
  getFrequenciesAndImpactsSuccess,
  postMatriceRiskSuccess,
  // Conformity Scale
  getConformityScaleAction,
  getConformityScaleByControlSuccessAction,
  getConformityScaleSuccessAction,
} from "../Risks/actions.js"

import { setLoaderDataAction } from "../Templates/actions.js"

import {
  responseTypeIsError,
  responseTypeIsSuccess,
  responseTypeIsWarning,
  manageErrorGenerator,
  manageSuccessGenerator,
  manageWarningGenerator,
} from "Containers/App/saga"

// Utils
import request from "Utils/request"
import { config } from "Utils/config"
import { getCors, postCors, postFileCors, patchCors, deleteCors } from "Utils/rulesCors"
// Actions

import {
  setErrorMessage
} from "Containers/Messages/actions"

import { selectCurrentToken } from "Containers/Login/selectors.js"
//**********************************************************************************************
//************************************* RISK  **************************************************
//**********************************************************************************************
//GET_RISK
function* getAllRiskSaga() {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const requestURL = `${FORM_BACK_URL}/risk`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getRiskSuccess(response.body))
      }
    }
  } catch (err) {
    console.error("[route] => /risk => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* getRiskNoArchiveSaga() {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const requestURL = `${FORM_BACK_URL}/availableRisks`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getRiskSuccess(response.body))
      }
    }
  } catch (err) {
    console.error("[route] => /availableRisks => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
//GET_RISK_BY_ID
function* getRiskByIdSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { riskId } = payload
  const requestURL = `${FORM_BACK_URL}/risk/${riskId}`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getRiskByIdSuccess(response.body))
      }
    }
  } catch (err) {
    console.error("[route] => /risk/:riskId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
//GET_RISK_BY_MAPPING_RISK_ID
function* getRiskByMappingIdSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { mappingRiskId } = payload
  const requestURL = `${FORM_BACK_URL}/risksAssociatedToMapping/${mappingRiskId}`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getRiskByMappingRiskIdSuccess(response.body))
      }
    }
  } catch (err) {
    console.error("[route] => /risksAssociatedToMapping/:mappingRiskId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
// POST_RISK
function* postRiskSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { riskToCreate } = payload
  const requestURL = `${FORM_BACK_URL}/risk`

  try {
    const response = yield call(request, requestURL, postCors(riskToCreate, specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
      yield put(setLoaderDataAction(false))
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
        yield put(getRiskAction())
        yield put(postRiskSuccess(response.body))
        yield put(setLoaderDataAction(false))
      }
    }
  } catch (err) {
    console.error("[route] => /risk => ERROR => ", err)
    yield put(setErrorMessage(err))
    yield put(setLoaderDataAction(false))
  }
}
// PATCH_RISK_BY_ID
function* patchRiskByIdSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { riskToUpdate, riskId } = payload
  const requestURL = `${FORM_BACK_URL}/risk/${riskId}`

  try {
    const response = yield call(request, requestURL, patchCors(riskToUpdate, specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
      yield put(setLoaderDataAction(false))
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
        yield put(getRiskAction())
        yield put(setLoaderDataAction(false))
      }
    }
  } catch (err) {
    console.error("[route] => /risk/:riskId => ERROR => ", err)
    yield put(setErrorMessage(err))
    yield put(setLoaderDataAction(false))
  }
}
//DELETE_RISK_BY_ID
function* deleteRiskByIdSag({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { riskId } = payload
  const requestURL = `${FORM_BACK_URL}/deleteOrArchiveRisk/${riskId}`

  try {
    const response = yield call(request, requestURL, patchCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
        yield put(getRiskNoArchiveAction())
      }
    }
  } catch (err) {
    console.error("[route] => /deleteOrArchiveRisk/:riskId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
//******************************************************************************
//************************** RISK RESIDUAL *************************************
//******************************************************************************
//GET_RISK_RESIDUAL
function* getAllRiskResidualSaga() {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const requestURL = `${FORM_BACK_URL}/riskResidual`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getRiskResidualSuccess(response.body))
      }
    }
  } catch (err) {
    console.error("[route] => /riskResidual => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
//GET_RISK_RESIDUAL_BY_ID
function* getRiskResidualByIdSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { riskId } = payload
  const requestURL = `${FORM_BACK_URL}/riskResidual/${riskId}`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getRiskResidualByIdSuccess(response.body))
      }
    }
  } catch (err) {
    console.error("[route] => /riskResidual/:riskId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
// POST_RISK_RESIDUAL
function* postRiskResidualSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { riskToCreate } = payload
  const requestURL = `${FORM_BACK_URL}/riskResidual`

  try {
    const response = yield call(request, requestURL, postCors(riskToCreate, specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
        yield put(getRiskResidualAction())
        yield put(postRiskResidualSuccess(response.body))
        yield put(setLoaderDataAction(false))
      }
    }
  } catch (err) {
    console.error("[route] => /riskResidual => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
// PATCH_RISK_RESIDUAL_BY_ID
function* patchRiskResidualByIdSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { riskResidualToUpdate, riskResidualId } = payload
  const requestURL = `${FORM_BACK_URL}/riskResidual/${riskResidualId}`

  try {
    const response = yield call(
      request,
      requestURL,
      patchCors(riskResidualToUpdate, specificHeaders)
    )
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
      yield put(setLoaderDataAction(false))
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
        yield put(getRiskResidualAction())
        yield put(setLoaderDataAction(false))
      }
    }
  } catch (err) {
    console.error("[route] => //riskResidual/:riskResidualId => ERROR => ", err)
    yield put(setErrorMessage(err))
    yield put(setLoaderDataAction(false))
  }
}
// DELETE_RISK_RESIDUAL_BY_ID
function* deleteRiskResidualByIdSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { riskResidualId } = payload
  const requestURL = `${FORM_BACK_URL}/riskResidual/${riskResidualId}`

  try {
    const response = yield call(request, requestURL, deleteCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
        yield put(getRiskResidualAction())
        yield put(setLoaderDataAction(false))
      }
    }
  } catch (err) {
    console.error("[route] => /riskResidual/:riskResidualId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
//******************************************************************************
//************************** MAPPING RISK **************************************
//******************************************************************************
//GET_MAPPING_RISK
function* getAllMappingRiskSaga() {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const requestURL = `${FORM_BACK_URL}/mappingRisks`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getMappingRiskSuccess(response.body))
      }
    }
  } catch (err) {
    console.error("[route] => /mappingRisks => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
//GET_MAPPING_RISK_BY_ID
function* getMappingRiskByIdSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { riskId, date, mode } = payload
  const requestURL =
    mode === "activities"
      ? `${FORM_BACK_URL}/mappingRisks/${riskId}?mode=activities&date=${date}`
      : `${FORM_BACK_URL}/mappingRisks/${riskId}`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getMappingRiskByIdSuccess(response.body))
      }
    }
  } catch (err) {
    console.error("[route] => /mappingRisks/:riskId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* getHistoricOfMappingRiskByIdSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { mappingRiskId } = payload
  const endUrl = `/historicOfMappingRisks/${mappingRiskId}`
  const requestURL = `${FORM_BACK_URL}${endUrl}`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getHistoricOfMappingRiskByIdSuccess(response.body))
      }
    }
  } catch (err) {
    console.error("[route] => /historicOfMappingRisks/:mappingRiskId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

// POST_MAPPING_RISK
function* postMappingRiskSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { mappingRiskToCreate } = payload
  const requestURL = `${FORM_BACK_URL}/mappingRisks`

  try {
    const response = yield call(request, requestURL, postCors(mappingRiskToCreate, specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getMappingRiskAction())
        yield put(postMappingRiskSuccess(response.body))
        yield put(setLoaderDataAction(false))
      }
    }
  } catch (err) {
    console.error("[route] => /mappingRisks => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

// DELETE_MAPPING_RISK
function* deleteMappingRiskSaga({ payload }) {
  const mappingRiskId = payload
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `mappingRisks/${mappingRiskId}`
  const requestURL = `${FORM_BACK_URL}/${endPath}`

  try {
    const response = yield call(request, requestURL, deleteCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsWarning(response)) {
        yield call(manageWarningGenerator, { response, showMessageToUser: true })
      } else if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getMappingRiskAction())
      }
    }
  } catch (err) {
    console.error(`[route] => /${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}
//******************************************************************************
//************************** Matrice RISK **************************************
//******************************************************************************
//GET_MATRICE_RISK
function* getMatriceRiskSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  // const { languageID } = payload
  const requestURL = `${FORM_BACK_URL}/riskMatrix`
  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getMatriceRiskSuccess(response.body))
      }
    }
  } catch (err) {
    console.error("[route] => /riskMatrix => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
//GET_MATRICE_RISK_BY_ID
function* getMatriceRiskByIdSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { risksMatrixId } = payload
  const requestURL = `${FORM_BACK_URL}/riskMatrix/${risksMatrixId}`
  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getMatriceRiskByIdSuccess(response.body))
      }
    }
  } catch (err) {
    console.error("[route] => /riskMatrix/:risksMatrixId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
// GET_CALCUL_RISK_BRUT_RESULT
function* getCalculRiskBrutResultSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { dimensionIds } = payload
  const requestURL = `${FORM_BACK_URL}/calculatedRiskBrutResult`

  try {
    const response = yield call(request, requestURL, postCors(dimensionIds, specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
      yield put(setLoaderDataAction(false))
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getCalculRiskBrutResultSuccess(response.body))
        yield put(setLoaderDataAction(false))
      }
    }
  } catch (err) {
    console.error("[route] => /mappingRisks => ERROR => ", err)
    yield put(setErrorMessage(err))
    yield put(setLoaderDataAction(false))
  }
}

// POST_MATRICE_RISK
function* postMatriceRiskSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { matrixRiskToCreate } = payload
  const requestURL = `${FORM_BACK_URL}/riskMatrix`

  try {
    const response = yield call(request, requestURL, postCors(matrixRiskToCreate, specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
      yield put(setLoaderDataAction(false))
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
        yield put(postMatriceRiskSuccess(response.body))
        yield put(getMatriceRiskAction())
        yield put(setLoaderDataAction(false))
      }
    }
  } catch (err) {
    console.error("[route] => /mappingRisks => ERROR => ", err)
    yield put(setErrorMessage(err))
    yield put(setLoaderDataAction(false))
  }
}
//PATCH_MATRICE_RISK_BY_ID
function* patchMatriceRiskByIdSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { matrixRiskToUpdate, risksMatrixId } = payload
  const requestURL = `${FORM_BACK_URL}/riskMatrix/${risksMatrixId}`
  try {
    const response = yield call(request, requestURL, patchCors(matrixRiskToUpdate, specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
        yield put(getMatriceRiskAction())
        yield put(setLoaderDataAction(false))
      }
    }
  } catch (err) {
    console.error("[route] => /riskMatrix/:risksMatrixId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
//GET_FRENQUENCIES_AND_IMPACTS
function* getFrequenciesAndImpactsSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { languageID } = payload
  const requestURL = `${FORM_BACK_URL}/frequenciesAndImpacts?lang=${languageID}`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getFrequenciesAndImpactsSuccess(response.body))
      }
    }
  } catch (err) {
    console.error("[route] => /frequenciesAndImpacts => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
//******************************************************************************
//************************  Echelle de conformité ******************************
//******************************************************************************
//GET_CONFORMITY_SCALE
function* getConformityScalesSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const requestURL = `${FORM_BACK_URL}/conformityScales`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getConformityScaleSuccessAction(response.body))
      }
    }
  } catch (err) {
    console.error("[route] => /conformityScales => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
//GET_CONFORMITY_SCALE_BY_CONTROL
function* getConformityScaleByControlSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { controlId, mappingRiskId } = payload
  const paramsRequest = controlId ? `controlId=${controlId}` : `mappingRiskId=${mappingRiskId}`
  const requestURL = `${FORM_BACK_URL}/conformityScaleAssociated?${paramsRequest}`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getConformityScaleByControlSuccessAction(response.body))
      }
    }
  } catch (err) {
    console.error("[route] => /conformityScaleAssociated?controlId=${controlId} => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
//POST_CONFORMITY_SCALE
function* postConformityScalesSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { conformityScaleToCreate } = payload
  const requestURL = `${FORM_BACK_URL}/conformityScales`

  try {
    const response = yield call(
      request,
      requestURL,
      postCors(conformityScaleToCreate, specificHeaders)
    )
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
      yield put(setLoaderDataAction(false))
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
        yield put(getConformityScaleAction())
        yield put(setLoaderDataAction(false))
      }
    }
  } catch (err) {
    console.error("[route] => /conformityScales => ERROR => ", err)
    yield put(setErrorMessage(err))
    yield put(setLoaderDataAction(false))
  }
}

function* riskSaga() {
  // Risk
  yield takeEvery(GET_RISK, getAllRiskSaga)
  yield takeEvery(GET_RISK_NO_ARCHIVE, getRiskNoArchiveSaga)
  yield takeEvery(GET_RISK_BY_ID, getRiskByIdSaga)
  yield takeEvery(GET_RISK_BY_MAPPING_RISK_ID, getRiskByMappingIdSaga)
  yield takeEvery(POST_RISK, postRiskSaga)
  yield takeEvery(PATCH_RISK_BY_ID, patchRiskByIdSaga)
  yield takeEvery(DELETE_RISK_BY_ID, deleteRiskByIdSag)
  // Risk Residual
  yield takeEvery(GET_RISK_RESIDUAL, getAllRiskResidualSaga)
  yield takeEvery(GET_RISK_RESIDUAL_BY_ID, getRiskResidualByIdSaga)
  yield takeEvery(POST_RISK_RESIDUAL, postRiskResidualSaga)
  yield takeEvery(PATCH_RISK_RESIDUAL_BY_ID, patchRiskResidualByIdSaga)
  yield takeEvery(DELETE_RISK_RESIDUAL_BY_ID, deleteRiskResidualByIdSaga)
  // Mapping Risk
  yield takeEvery(GET_MAPPING_RISK, getAllMappingRiskSaga)
  yield takeEvery(GET_MAPPING_RISK_BY_ID, getMappingRiskByIdSaga)
  yield takeEvery(GET_HISTORIC_OF_MAPPING_RISK_BY_ID, getHistoricOfMappingRiskByIdSaga)
  yield takeEvery(POST_MAPPING_RISK, postMappingRiskSaga)
  yield takeEvery(DELETE_MAPPING_RISK_BY_ID, deleteMappingRiskSaga)
  // Matrice Risk
  yield takeEvery(GET_MATRICE_RISK, getMatriceRiskSaga)
  yield takeEvery(GET_MATRICE_RISK_BY_ID, getMatriceRiskByIdSaga)
  yield takeEvery(GET_CALCUL_RISK_BRUT_RESULT, getCalculRiskBrutResultSaga)
  yield takeEvery(GET_FRENQUENCIES_AND_IMPACTS, getFrequenciesAndImpactsSaga)
  yield takeEvery(POST_MATRICE_RISK, postMatriceRiskSaga)
  yield takeEvery(PATCH_MATRICE_RISK_BY_ID, patchMatriceRiskByIdSaga)
  // Conformity Scales
  yield takeEvery(GET_CONFORMITY_SCALE, getConformityScalesSaga)
  yield takeEvery(GET_CONFORMITY_SCALE_BY_CONTROL, getConformityScaleByControlSaga)
  yield takeEvery(POST_CONFORMITY_SCALE, postConformityScalesSaga)
}

export default riskSaga
